import React, { useState } from 'react';
import { chevronBackCircle, chevronForwardCircle } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { PickChallengerItemLoader } from '../../skeletalLoaders/SkeletalLoaders';
import FighterTile from './FighterTile';
import '../../../styles/fight/challenger/PaginatedUsers.scss';

const PaginatedUsers = ({ heading, isLoading, loadedFighters, perPage = 3, selectedFightId, onSelect }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(loadedFighters.length / perPage);

  // Calculate start and end indices for current page
  const startIndex = (currentPage - 1) * perPage;
  const endIndex = startIndex + perPage;

  // Get fighters for current page
  const currentFighters = loadedFighters.slice(startIndex, endIndex);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className='paginated-users-container'>
      <p className='paginated-users-title'>{heading}</p>
      {isLoading ? (
        [...Array(6)].map(val => (
          <div className='fighter-placeholder' key={val}>
            <PickChallengerItemLoader />
          </div>
        ))
      ) : (
        <div className='pagination-controls'>
          <button
            className='nav-button back-button'
            type='button'
            onClick={handlePreviousPage}
            disabled={currentPage === 1}>
            <IonIcon icon={chevronBackCircle} />
          </button>

          <div className='center-content'>
            <div className='fighters-grid'>
              {currentFighters.map((fighter, index) => (
                <FighterTile
                  fighter={fighter}
                  selected={selectedFightId === fighter.id}
                  onClick={(event, selectedIcon) => onSelect(fighter, selectedIcon)}
                  iconIndex={index}
                  key={fighter.id}
                />
              ))}
            </div>
          </div>

          <button
            className='nav-button forward-button'
            type='button'
            onClick={handleNextPage}
            disabled={currentPage === totalPages}>
            <IonIcon icon={chevronForwardCircle} />
          </button>
        </div>
      )}
    </div>
  );
};

export default PaginatedUsers;
